import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class ArrowLeftIcon extends Component {
    render() {
        return (
            <svg {...this.props} height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M6.293 13.707l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414L4.414 7H14a1 1 0 0 1 0 2H4.414l3.293 3.293a.997.997 0 0 1 0 1.414.999.999 0 0 1-1.414 0z"/></svg>
        )
    }
}

export default withCssClassName(ArrowLeftIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/arrow-left-icon.js